import { Separator } from "../../separator";
import React from "react";
import useIsMobile from "../../../hooks/use-is-mobile";
interface SubHeaderProps extends React.HtmlHTMLAttributes<HTMLDivElement> {
  subheaderMain?: string;
  subheaderSub?: string;
  paddingLeftRight?: number;
}

const TextSubheader = ({ subheaderMain, subheaderSub, paddingLeftRight = 0, children }: SubHeaderProps) => {
  const { isMobile } = useIsMobile();
  return (
    <div style={{ textAlign: isMobile ? "center" : "start", padding: isMobile ? `0` : `0 ${paddingLeftRight}px` }}>
      <div className="polymer-text-subheader__container">
        <div>
          {subheaderMain && <p className="polymer-text-subheader__main">{subheaderMain}</p>}
          {subheaderSub && <p className="polymer-text-subheader__sub">{subheaderSub}</p>}
        </div>
        {children}
      </div>
      <Separator />
    </div>
  );
};

export default TextSubheader;
